import { render } from "./TheProjects.vue?vue&type=template&id=1c4fb7c9&scoped=true"
import script from "./TheProjects.vue?vue&type=script&lang=js"
export * from "./TheProjects.vue?vue&type=script&lang=js"

import "./TheProjects.vue?vue&type=style&index=0&id=1c4fb7c9&scoped=true&lang=css"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/cyrill.codeberg.page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4fb7c9"]])

export default __exports__